module.exports = __webpack_public_path__ + "static/media/102.79a90db3.gif";